import { Flex, styled, TextV2 } from '@withjoy/joykit';
import { listButtonStates } from '@apps/admin/routes/Dashboard/common/commonDasboard.styles';

export const OptionsContainer = styled(Flex)`
  column-gap: 1rem;
  flex-direction: column;
  row-gap: 1rem;
`;

export const Option = styled.button`
  ${listButtonStates};
  align-items: center;
  column-gap: 1rem;
  display: flex;
  height: 5rem;
  padding: 1rem 1.5rem;
  width: 100%;
`;

export const OptionContent = styled(TextV2)`
  display: flex;
  justify-content: space-between;
  flex: 1 1 auto;
`;

export const Checkbox = styled.button<{ selected: boolean }>`
  align-items: center;
  background: ${({ theme, selected }) => (selected ? theme.colors.black : theme.colors.white)};
  border-color: ${({ theme, selected }) => (selected ? theme.colors.black : theme.colors.gray5)};
  border-style: solid;
  border-width: 0.0625rem;
  border-radius: 0.125rem;
  display: flex;
  height: 1.5rem;
  justify-content: center;
  width: 1.5rem;

  svg {
    display: ${({ selected }) => (selected ? 'block' : 'none')};
    color: ${({ theme, selected }) => (selected ? theme.colors.white : theme.colors.black)};
    stroke: ${({ theme, selected }) => (selected ? theme.colors.white : theme.colors.black)};
    stroke-width: 0.125rem;
    width: 0.75rem;
  }
`;
